/**
 * ColorScalesSection.tsx
 * Semantic Color Scales - brand and contextual colors with meaning
 */

import React from 'react';
import { Card, CardHeader, CardBody } from '@enfomentis/ui';
import { Divider } from '@enfomentis/ui';

// Semantic colors - brand and contextual colors with specific meaning
const semanticColorScales = [
  { name: 'primary', desc: 'Primary brand color (Blue)' },
  { name: 'secondary', desc: 'Secondary brand (Teal)' },
  { name: 'success', desc: 'Success states (Green)' },
  { name: 'warning', desc: 'Warning states (Orange)' },
  { name: 'danger', desc: 'Danger/Error states (Red)' },
  { name: 'default', desc: 'Default/Neutral (Gray)' },
] as const;

// Color scale shades
const shades = ['50', '100', '200', '300', '400', '500', '600', '700', '800', '900'] as const;

export const ColorScalesSection: React.FC = () => {
  return (
    <div className="space-y-6">
      <Card shadow="lg" isHoverable>
        <CardHeader>
          <div className="space-y-2">
            <h3 className="text-xl font-semibold text-text-primary">Semantic Color Scales</h3>
            <Divider />
            <p className="text-text-secondary">Brand and contextual colors with specific meaning - use these for consistent theming</p>
          </div>
        </CardHeader>
        <CardBody>
          <div className="space-y-8">
            {semanticColorScales.map((scale) => (
              <div key={scale.name} className="space-y-4">
                <div>
                  <h4 className="font-semibold text-text-primary capitalize">{scale.name}</h4>
                  <p className="text-sm text-text-secondary">{scale.desc}</p>
                </div>
                
                <div className="grid grid-cols-5 gap-2">
                  {shades.map((shade) => (
                    <div 
                      key={`${scale.name}-${shade}`}
                      className={`h-12 rounded-lg flex flex-col items-center justify-center text-xs font-medium border border-border`}
                      style={{ 
                        backgroundColor: `var(--color-${scale.name}-${shade})`,
                        color: parseInt(shade) >= 500 ? 'white' : 'black'
                      }}
                    >
                      <span>{shade}</span>
                    </div>
                  ))}
                </div>
              </div>
            ))}
          </div>
        </CardBody>
      </Card>
    </div>
  );
};